import React from 'react';
import { uid } from 'uid';
import { ReactComponent as Bike } from '../../assets/icons/motor_bike.svg';
import { ReactComponent as Car } from '../../assets/icons/car.svg';
import { ReactComponent as Van } from '../../assets/icons/mini_van.svg';
import { ReactComponent as Truck } from '../../assets/icons/delivery_truck.svg';
import { LGA, STATION } from '../../interfaces/shipping.interface';

export const vehicleTypes = ['BIKE', 'CAR', 'VAN', 'TRUCK'];
export type VEHICLES = typeof vehicleTypes[number];

export interface VehicleDetails {
  id: string;
  name: string;
  description: string;
  icon: React.ReactNode;
}

export const vehiclesDictionary: { [x in VEHICLES]: VehicleDetails } = {
  BIKE: {
    id: uid(8),
    name: 'Motor Bike',
    description:
      'Ideal for lightweight items: Documents, human hair, phones, etc.',
    icon: <Bike />,
  },
  CAR: {
    id: uid(8),
    name: 'Car',
    description:
      'For items that will fit into a car boot: Bag of clothes and shoes, a microwave oven etc.',
    icon: <Car />,
  },
  VAN: {
    id: uid(8),
    name: 'Mini Van',
    description:
      'For items too large to fit in a car boot: Large Bag of clothes or shoes, a small fridge etc.',
    icon: <Van />,
  },
  TRUCK: {
    id: uid(8),
    name: 'Truck',
    description:
      'Perfect for moving very large items: Furniture set, office equipment, etc.',
    icon: <Truck />,
  },
};

export interface FormSteps {
  name: string;
  label: string;
  caption: string;
}

export const formSteps: FormSteps[] = [
  {
    name: 'pick-up',
    label: 'Pick up location',
    caption: '1'
  },
  {
    name: 'shipment-details',
    label: 'Shipment details',
    caption: '2'
  },
  {
    name: 'upload-item',
    label: 'Upload item',
    caption: '3'
  },
];

export const getAddressComponent = (
  geoData: google.maps.GeocoderResult[],
  searchKey: string
) => {
  const addressComponet = geoData[0].address_components?.find(
    (address_component) => address_component.types.includes(searchKey)
  );
  return addressComponet;
};

export const getLgaFromGeoData = (
  geoData: google.maps.GeocoderResult[],
  lgasArg: LGA[]
): LGA | null => {
  const GeoLga = getAddressComponent(geoData, 'administrative_area_level_2');
  const selectedLga = lgasArg?.find(
    (lga) =>
      lga?.LGAName?.toLowerCase()?.replace(/[^a-zA-Z0-9]/g, '_') ===
      GeoLga?.long_name.toLowerCase()?.replace(/[^a-zA-Z0-9]/g, '_')
  );
  return selectedLga || null;
};

export const getCountryFromGeoData = (
  geoData: google.maps.GeocoderResult[]
) => {
  const country = getAddressComponent(geoData, 'country');
  return country;
};

export const getStationFromGeoData = (
  geoData: google.maps.GeocoderResult[],
  stationsarg: STATION[]
): STATION | null => {
  const GeoStation = getAddressComponent(
    geoData,
    'administrative_area_level_1'
  );
  const selectedStation = stationsarg?.find((station) =>
    GeoStation?.long_name
      ?.toLowerCase()
      ?.includes(station.StationName.toLowerCase())
  );
  return selectedStation || null;
};
